import React from 'react'
import htmlEscape from "htmlEscape";

function searchParamsParser (urlParams) {
  const parsed = {};
  const params = urlParams.split('/');

  const remapProps = {
    r: "region",
    q: "city",
    postcode: "postcode",
    d: "distance",
    gv: "type",
    page: "page"
  };

  for (let param of params) {
    if (param) {
      param = decodeURIComponent(param);
      let matches = param.match(/^(r|postcode|q|d|gv|page)-([^/]+)$/);
      if (matches) {
        const key = remapProps[matches[1]] || matches[1];
        parsed[key] = htmlEscape(matches[2]);
      }
      else {
        parsed.specialism = htmlEscape(param);
      }
    }
  }

  return parsed;
}

export default searchParamsParser;
